// src/components/PaywallPlanosModal.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

// IMPORTANTe: troque a região se suas Cloud Functions estiverem em outra região
const functions = getFunctions(app, "us-central1");
const auth = getAuth(app);

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(10,14,25,0.55);
  backdrop-filter: blur(8px) saturate(120%);
  -webkit-backdrop-filter: blur(8px) saturate(120%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Card = styled.div`
  width: min(1000px, 96vw);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0,0,0,.2);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 24px;
  color: #0f172a;
  text-align: center;
`;

const Sub = styled.p`
  margin: 0;
  color: #334155;
  text-align: center;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
`;

const PlanCard = styled.div`
  background: #fff;
  border: 1px solid #e6ecf5;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 6px 20px rgba(58,121,237,0.08);
  display: flex;
  flex-direction: column;
`;

const PlanTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
`;

const Price = styled.p`
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
  color: #3a79ed;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
`;
const Item = styled.li` margin-bottom: 6px; `;

const CTA = styled.button`
  margin-top: auto;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-weight: 700;
  font-size: 16px;
  background: #3a79ed;
  color: #fff;
  cursor: pointer;
  transition: transform .06s ease, opacity .2s ease;
  &:active { transform: translateY(1px); }
  &[disabled] { opacity: .6; cursor: not-allowed; }
`;

const ErrorBox = styled.div`
  background: #ffe6e6;
  border: 1px solid #ffb3b3;
  color: #7a1f1f;
  border-radius: 12px;
  padding: 10px 12px;
  text-align: center;
`;

const planos = [
  { id: "single", titulo: "Single", precoLabel: "R$ 64,90/mês", bullets: ["Agendamentos básicos", "1 colaborador", "Suporte por WhatsApp"] },
  { id: "pro", titulo: "Pro", precoLabel: "R$ 94,90/mês", bullets: ["Agendamentos avançados", "Até 5 colaboradores", "Suporte por WhatsApp"] },
  { id: "enterprise", titulo: "Enterprise", precoLabel: "R$ 149,90/mês", bullets: ["Recursos completos", "Equipe ilimitada", "Suporte prioritário"] },
];

export default function PaywallPlanosModal({ daysLeft = 0 }) {
  const [erro, setErro] = useState("");
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden"; // trava scroll do app
    return () => { document.body.style.overflow = prev; };
  }, []);

  const handleAssinar = async (planId) => {
    setErro("");
    const user = auth.currentUser;
    if (!user) {
      setErro("Você precisa estar logado para assinar.");
      return;
    }

    const newTab = window.open("about:blank", "_blank"); // abre aba no gesto do usuário
    try {
      setLoadingPlanId(planId);
      const createStripePaymentLink = httpsCallable(functions, "createStripePaymentLink");
      const { data } = await createStripePaymentLink({ planId });
      if (data?.url) {
        if (newTab) newTab.opener = null;
        if (newTab) newTab.location = data.url;
      } else {
        if (newTab) newTab.close();
        throw new Error("Não foi possível gerar o link de pagamento.");
      }
    } catch (e) {
      if (newTab) newTab.close();
      console.error(e);
      setErro(e?.message || "Falha ao iniciar o pagamento. Tente novamente.");
    } finally {
      setLoadingPlanId(null);
    }
  };

  return (
    <Backdrop>
      <Card role="dialog" aria-modal="true" aria-labelledby="paywall-title">
        <Title id="paywall-title">Sua vigencia acabou 🥲</Title>
        <Sub>Para continuar usando o <strong style={{ color: "#3a79ed" }}>Bigode.app</strong>, escolha um plano abaixo.</Sub>
        {daysLeft > 0 && <Sub>Faltam <strong style={{ color: "#3a79ed" }}>{daysLeft}</strong> dias — aproveite!</Sub>}
        {erro && <ErrorBox>{erro}</ErrorBox>}

        <Grid>
          {planos.map((p) => (
            <PlanCard key={p.id}>
              <PlanTitle>{p.titulo}</PlanTitle>
              <Price>{p.precoLabel}</Price>
              <List>
                {p.bullets.map((b, i) => <Item key={i}>{b}</Item>)}
              </List>
              <CTA
                onClick={() => handleAssinar(p.id)}
                disabled={loadingPlanId === p.id}
              >
                {loadingPlanId === p.id ? "Gerando link..." : "Assinar"}
              </CTA>
            </PlanCard>
          ))}
        </Grid>
      </Card>
    </Backdrop>
  );
}
